import { useState } from "react";

import styled from "styled-components";

import { ButtonLink } from "~/components/Button";
import { Separator } from "~/components/Elements";
import * as Form from "~/components/Form";
import Modal from "~/components/Modal";
import Spacer, { Axis } from "~/components/Spacer";

const MainContent = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-top: 20px;
  }
`;
const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;
const TitleText = styled.div`
  font-size: 32px;
  font-weight: 800;
  line-height: 40px;
`;

type DDQModalDeclineProps = {
  onSubmit?: (reason: string) => void;
  onClose: () => void;
  vaspName: string;
};

export default function DDQModalDecline({ onSubmit, onClose, vaspName }: DDQModalDeclineProps) {
  const [reason, setReason] = useState("");

  const onSubmitClick = () => {
    if (onSubmit) {
      onSubmit(reason);
    }
  };

  return (
    <>
      <Modal active onClose={onClose}>
        <Modal.Body
          styles={{
            display: "flex",
            flexDirection: "column",
            maxWidth: 540,
          }}
        >
          <TitleText>Decline {vaspName} access to your DDQ</TitleText>
          <Spacer axis={Axis.VERTICAL} size={10} />
          <MainContent>
            <Separator style={{ width: "100%", backgroundColor: "#D2D2D2" }} sized={null} />
            <div style={{ fontSize: "12px", fontWeight: "bolder" }}>{"Provide reason for decline (optional)"}</div>
            <Form.ControlInput style={{ width: "100%" }} onChange={(e) => setReason(e.target.value)} />
          </MainContent>
        </Modal.Body>
        <Modal.Footer>
          <SpaceBetween>
            <ButtonLink onClick={onClose}>Close</ButtonLink>
            <ButtonLink color="danger" onClick={onSubmitClick}>
              Decline access
            </ButtonLink>
          </SpaceBetween>
        </Modal.Footer>
      </Modal>
    </>
  );
}
